import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout/Layout';
import Pagination from '../../components/ui/Pagination';
import api from '../../api/axios';

function fmt(dt) {
  if (!dt) return '—';
  return new Date(dt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function AttendanceHistory() {
  const [records, setRecords] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const limit = 15;

  async function load(p = page) {
    setLoading(true);
    try {
      const res = await api.get(`/attendance/my-history?page=${p}&limit=${limit}`);
      setRecords(res.data.attendance);
      setTotal(res.data.total);
    } catch {}
    setLoading(false);
  }

  useEffect(() => { load(); }, [page]);

  return (
    <Layout>
      <div className="page-header">
        <h1>My Attendance History</h1>
        <p>View all your attendance records.</p>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}><span className="spinner spinner-dark" /></div>
        ) : records.length === 0 ? (
          <div className="empty-state">
            <div style={{ fontSize: '3rem' }}>📋</div>
            <p>No attendance records yet</p>
          </div>
        ) : (
          <>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Sign In</th>
                    <th>Sign Out</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Location</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map(r => {
                    let duration = '—';
                    if (r.sign_in_time && r.sign_out_time) {
                      const mins = Math.round((new Date(r.sign_out_time) - new Date(r.sign_in_time)) / 60000);
                      duration = `${Math.floor(mins / 60)}h ${mins % 60}m`;
                    }
                    return (
                      <tr key={r.id}>
                        <td style={{ fontWeight: 500 }}>{new Date(r.date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}</td>
                        <td>{fmt(r.sign_in_time)}</td>
                        <td>{fmt(r.sign_out_time)}</td>
                        <td>{duration}</td>
                        <td><span className={`badge badge-${r.status}`}>{r.status}</span></td>
                        <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.8rem', color: '#64748b' }}>
                          {r.sign_in_address || (r.sign_in_latitude ? `${r.sign_in_latitude}, ${r.sign_in_longitude}` : '—')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination page={page} total={total} limit={limit} onPageChange={setPage} />
          </>
        )}
      </div>
    </Layout>
  );
}
